import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import { getPrefix } from "../../../../../Application/slices/models";
import { ReducerEntityPrefixTypes, ReducerNamespaceTypes } from "../../../../../../enums";

export enum MembersModalEnum {
  AddUsersModal,
  RemoveUsersModal,
  FileUploadModal,
}

export interface GroupMembersModalsState {
  activeModal: MembersModalEnum | null;
  showLicenceStep: boolean;
}

export const initialState: GroupMembersModalsState = {
  activeModal: null,
  showLicenceStep: false,
};

const groupMembersModalsSlice = createSlice({
  name: getPrefix({
    namespace: ReducerNamespaceTypes.People,
    entity: ReducerEntityPrefixTypes.AddGroup,
    name: "membersModals",
  }),
  initialState,
  reducers: {
    setActiveModal(state: GroupMembersModalsState, action: PayloadAction<MembersModalEnum | null>) {
      state.activeModal = action.payload;
    },
    setShowLicenceStep(state: GroupMembersModalsState, action: PayloadAction<boolean>) {
      state.showLicenceStep = action.payload;
    },
    reset() {
      return initialState;
    },
  },
});

export const { setActiveModal, setShowLicenceStep, reset } = groupMembersModalsSlice.actions;

export default groupMembersModalsSlice.reducer;
